
import Vue, { PropType } from "vue";
import { LowBatteryAlertSetting } from "@/models";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseSelectorForm, { Option } from "@/components/BaseSelectorForm.vue";

type DataType = {
  threshold: string;
  thresholdOptions: Array<Option>;
};

export default Vue.extend({
  name: "LowBatteryAlertSettingEditor",

  components: {
    BaseSubmitButton,
    BaseSelectorForm,
  },

  props: {
    alertSetting: Object as PropType<LowBatteryAlertSetting>,
    loading: Boolean as PropType<boolean>,
    checked: Boolean as PropType<boolean>,
  },

  data(): DataType {
    return {
      threshold: "",
      thresholdOptions: [
        {
          name: "Low",
          value: "18",
        },
        {
          name: "Low",
          value: "30",
        },
      ],
    };
  },

  computed: {
    canSubmit(): boolean {
      return !!this.threshold;
    },

    thresholdSelectorClassText(): string {
      if (this.threshold === "18") {
        return "orange";
      } else if (this.threshold === "30") {
        return "red";
      }
      return "";
    },
  },

  watch: {
    alertSetting: function(n: LowBatteryAlertSetting) {
      this.threshold = n.threshold ? String(n.threshold) : "";
    },
  },

  methods: {
    save() {
      if (!this.canSubmit) {
        return;
      }

      this.$emit(
        "save-low-battery-alert-setting",
        new LowBatteryAlertSetting({
          companyId: this.$auth.companyId,
          threshold: parseInt(this.threshold) || 0,
        }),
      );
    },
  },
});
